import {useSelector} from "react-redux";

import {isEqual} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {generateMetaRegionName} from "../../../meta_data/utils/generate_meta_region_name";
import {parseQueryParamToInt} from "../../../utils/latest_query";
import {getSearchFilterPrefix} from "../../helpers/searches/generate_name";
import {offerSearchPhraseBuilder} from "../../helpers/searches/search_phrase";

interface IProps {
    multiRegionLimit?: number;
}

export const useOfferListingMapHeaderData = ({multiRegionLimit}: IProps = {}) => {
    const regions = useSelector((state: IRPStore) => state.offerListMap.selectedRegion, isEqual);
    const isMultiRegionSearch = regions.length > 1;
    const regionsOverLimitCount = multiRegionLimit ? regions.length - multiRegionLimit : 0;
    const regionsLimited = isMultiRegionSearch && multiRegionLimit ? regions.slice(0, multiRegionLimit) : regions;

    const is_luxury = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.is_luxury);
    const is_holiday = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.is_holiday);
    const price_lower_than_average = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.price_lower_than_average);
    const type = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.type);
    const construction_end_date = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.construction_end_date);

    const filterOptions = {
        is_luxury: Boolean(is_luxury),
        is_holiday: Boolean(is_holiday),
        price_lower_than_average: Boolean(price_lower_than_average),
        holiday_location: is_holiday,
        type: parseQueryParamToInt(type),
        construction_end_date: construction_end_date
    };
    const searchPrefix = getSearchFilterPrefix(filterOptions);
    const searchPhrase = offerSearchPhraseBuilder(filterOptions);
    const regionName =
        regionsLimited.length === 1 ? generateMetaRegionName(regionsLimited[0]) : regionsLimited.map((region) => region.full_name_reverted).join(" - ");

    return {searchPrefix, searchPhrase, regionName, regionsOverLimitCount};
};
import {useSelector} from "react-redux";

import {isEqual} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {generateMetaRegionName} from "../../../meta_data/utils/generate_meta_region_name";
import {parseQueryParamToInt} from "../../../utils/latest_query";
import {getSearchFilterPrefix} from "../../helpers/searches/generate_name";
import {offerSearchPhraseBuilder} from "../../helpers/searches/search_phrase";

interface IProps {
    multiRegionLimit?: number;
}

export const useOfferListingMapHeaderData = ({multiRegionLimit}: IProps = {}) => {
    const regions = useSelector((state: IRPStore) => state.offerListMap.selectedRegion, isEqual);
    const isMultiRegionSearch = regions.length > 1;
    const regionsOverLimitCount = multiRegionLimit ? regions.length - multiRegionLimit : 0;
    const regionsLimited = isMultiRegionSearch && multiRegionLimit ? regions.slice(0, multiRegionLimit) : regions;

    const is_luxury = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.is_luxury);
    const is_holiday = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.is_holiday);
    const price_lower_than_average = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.price_lower_than_average);
    const type = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.type);
    const construction_end_date = useSelector((state: IRPStore) => state.offerListMap.list.latestQuery.construction_end_date);

    const filterOptions = {
        is_luxury: Boolean(is_luxury),
        is_holiday: Boolean(is_holiday),
        price_lower_than_average: Boolean(price_lower_than_average),
        holiday_location: is_holiday,
        type: parseQueryParamToInt(type),
        construction_end_date: construction_end_date
    };
    const searchPrefix = getSearchFilterPrefix(filterOptions);
    const searchPhrase = offerSearchPhraseBuilder(filterOptions);
    const regionName =
        regionsLimited.length === 1 ? generateMetaRegionName(regionsLimited[0]) : regionsLimited.map((region) => region.full_name_reverted).join(" - ");

    return {searchPrefix, searchPhrase, regionName, regionsOverLimitCount};
};
